<!-- Put tooltips almost everywhere -->
<mat-sidenav-container class="sidenav-container">

  <!-- 

  <mat-sidenav /> previous [opened] value:
  [opened]="((callerService.isPortraitHandset$|| callerService.isTablet$) | async) === false"
  -->
  <mat-sidenav #drawer class="sidenav"
    [attr.role]="((callerService.isPortraitHandset$|| callerService.isTablet$) | async) ? 'dialog' : 'navigation'"
    [mode]="((callerService.isPortraitHandset$|| callerService.isTablet$) | async) ? 'over' : 'side'"
    [opened]="false">
    <mat-toolbar class="filters">
      Filters
      <span class="example-spacer"></span>
      <button type="button" mat-ripple mat-raised-button (click)="resetFilters()">Reset All</button>
    </mat-toolbar>

    <form [formGroup]="filterForm">
      <ng-container >
        <mat-toolbar-row>
          <h4>Budget</h4>
          <span class="example-spacer"></span>
          <mat-slide-toggle (change)="budgetDisableChange($event)" aria-label="Cancel budget filter">
            <!-- Reset -->
          </mat-slide-toggle>
        </mat-toolbar-row>
  
        <div class="byside">
          <mat-chip-listbox aria-label="Range selection">
            <mat-chip selected>₦50,000</mat-chip>
            <!--color="#f2f2f7"-->
            <span class="example-spacer"></span>
            <mat-chip color="primary" selected>₦200,000</mat-chip>
          </mat-chip-listbox>
          <mat-slider [disabled]="!budgetDisabled" [displayWith]="formatBudgetSliderLabel" showTickMarks discrete
            min="20000" step="25000" max="200000">
            <input title="min slider" value="100000" (valueChange)="budgetMinSliderChange($event)" matSliderStartThumb>
            <input title="max slider" value="175000" (valueChange)="budgetMaxSliderChange($event)" matSliderEndThumb>
          </mat-slider>
        </div>
      </ng-container>

      <ng-container *ngIf="feedViewControl.value === 'accommodation'">
        <mat-divider class="margin-up-down"></mat-divider>

        <mat-toolbar-row>
          <h4>House type</h4>
          <span class="example-spacer"></span>
          <mat-slide-toggle (change)="houseTypeDisableChange($event)" aria-label="Cancel house type filter">
            <!-- Reset -->
          </mat-slide-toggle>
        </mat-toolbar-row>
  
        <div class="byside">
          <mat-chip-listbox [disabled]="!houseTypeDisabled" aria-label="Specs selection" selectable="true" multiple="true">
            <mat-chip-option *ngFor="let houseType of availableHouseTypes"
              (selectionChange)="onChipClick($event, houseType)">
              {{ houseType.name }}
            </mat-chip-option>
          </mat-chip-listbox>
        </div>
      </ng-container>

      <!-- TODO: Will enable when we implement location -->
      <ng-container *ngIf="false">
        <mat-divider class="margin-up-down"></mat-divider>

        <mat-toolbar-row>
          <h4>Proximity (in km)</h4>
          <span class="example-spacer"></span>
          <mat-slide-toggle (change)="proximityDisableChange($event)" aria-label="Cancel proximity filter">
          </mat-slide-toggle>
        </mat-toolbar-row>
  
        <div class="byside">
          <mat-slider [disabled]="!proximityDisabled" [displayWith]="formatProximitySliderLabel" showTickMarks discrete
            step="500" min="100" max="3500">
            <input title="proximity slider" matSliderThumb value="1000" (valueChange)="proximitySliderChange($event)">
          </mat-slider>
  
          <!-- TODO: Will enable when we implement location -->
          <!-- based on the distance, filter the available places, the logic for replacing places when there's geo data is to replace the data source of the form element, not the html itself -->
          <mat-toolbar-row class="places-toolbar-row" *ngIf="false">
            <mat-form-field [hidden]="hidePlacesSelect">
              <mat-label>Places like:</mat-label>
              <mat-select title="Filter by places" role="listbox" [formControl]="places" multiple [disabled]="!proximityDisabled">
                <!-- <mat-optgroup *ngFor="let places of placesGroup" [label]="places.distace + ' meters from you'">
                  <mat-option *ngFor="let place of places.place" [value]="place.value">
                    {{place.viewValue}}
                  </mat-option>
                </mat-optgroup> -->
  
                <mat-option role="option" *ngFor="let place of placesList" [value]="place">{{ place }}</mat-option>
              </mat-select>
              <!-- use hint to communicate progress of getting current location -->
              <mat-hint class="straighten-text">
                Click <mat-icon>gps_fixed</mat-icon> to find places near you
              </mat-hint>
            </mat-form-field>
  
            <span class="example-spacer"></span>
  
            <button [disabled]="!proximityDisabled" type="button" aria-label="Toggle geolocation" mat-icon-button>
              <!-- switch between gps_fixed, gps_not_fixed and gps_off icons  when communicating geolocation status -->
              <mat-icon matTooltip="Filter with current location" aria-label="get geolocation toggle icon">gps_fixed
              </mat-icon>
            </button>
          </mat-toolbar-row>
        </div>
      </ng-container>
    </form>
  </mat-sidenav>
  <!-- !flex beats Material's .mat-drawer-content { display: block }, so the toolbar stays put
       and .new-scroller takes the remaining height. -->
  <mat-sidenav-content class="!flex !flex-col">

    <mat-toolbar color="accent">
      
      <!-- Sidebar button. Uncomment when we know what to do with the sidebar -->
      <!-- <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="(callerService.isPortraitHandset$ || callerService.isTablet$) | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button> -->

      <div class="feed-header">
        <span>{{currentViewing}}</span>

        <div class="spacer"></div>

        <mat-button-toggle-group [formControl]="feedViewControl" appearance="standard" name="current viewing" aria-label="Current viewing" multiple="false" vertical="false">
          <mat-button-toggle value="sale" aria-label="Show items for sale">
            <mat-icon>sell</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="accommodation" aria-label="Show houses for rent">
            <mat-icon>bed</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <!-- show number of available properties, and the filter criteria the user has chosen -->
    </mat-toolbar>

    <!-- Add Content Here -->

    <!-- TODO: bug, if we leave the site idle, and come back to it; duplicate post is sent. -->
    <div *ngIf="(feedData$ | async)?.size; else noFeed" class="new-scroller" [class.sale-grid]="feedViewControl.value === 'sale'" [class.house-grid]="feedViewControl.value === 'accommodation'">
      <app-feed-content *ngFor="let feed of feedData$ | async | keyvalue: preserveMapOrder; trackBy: trackByKey" [post]="feed.value">
      </app-feed-content>
    </div>
    <ng-template #noFeed>
      <div class="new-scroller">
        <ng-container *ngIf="isFetching; else noPost">
          <mat-spinner mode="indeterminate" aria-label="Loading more content">
          </mat-spinner>
        </ng-container>
        <ng-template #noPost>
          <p class="text-center">No post yet.</p>
        </ng-template>
      </div>
    </ng-template>

    <!-- <cdk-virtual-scroll-viewport itemSize="625" class="scroller" orientation="vertical">

      <div class="feed-row" *cdkVirtualFor="let feeds of feedData;
        let index = index;
        let count = count;
        let first = first;
        let last = last;
        let even = even;
        let odd = odd;">

      <div class="col-3" *ngFor="let feed of feeds">
        <app-feed-content [post]="feed">

        </app-feed-content>
      </div>

    </div>

    </cdk-virtual-scroll-viewport> -->
        <!--
            switch statement doesn't work in app-feed-content
            when switching between displaying app-feed-accommodation-content & app-feed-sale-content
          -->

      <!-- https://stackblitz.com/edit/angular-material2-list-of-cards?file=app%2Fapp.component.html -->


      <!-- show only if user at bottom of page & in view -->
      <!-- <mat-spinner class="center margin-top-bottom" mode="indeterminate" aria-label="loading more content">
      </mat-spinner> -->

      <div class="md:hidden z-10 fixed right-4 bottom-16 flex flex-col gap-4">
        <button (click)="callerService.openCreateAccommodationPostDialog()" mat-fab color="accent" type="button" aria-label="Post accommodation" class="shadow-card-elevated">
          <mat-icon>domain_add</mat-icon>
        </button>

        <button (click)="callerService.openCreateSalePostDialog()" mat-fab color="primary" type="button" aria-label="Post sale item" class="shadow-card-elevated">
          <mat-icon>new_label</mat-icon>
        </button>
      </div>

    <!-- Stop Add Content Here -->
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- <cdk-virtual-scroll-viewport itemSize="100">
    <mat-list *cdkVirtualFor="let fact of dataSource">
      
        <mat-card *ngFor="let g of fact.states[0] || fact" class="fact-item">

  <img mat-card-image src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Photo of a Shiba Inu">

          <mat-card-header>
            <div mat-card-avatar class="example-header-image"></div>
            <mat-card-title>Shiba Inu</mat-card-title>
            <mat-card-subtitle>Dog Breed</mat-card-subtitle>
          </mat-card-header>
          
          {{ g || fact.year }}

          <mat-card-content>
            <p>
              The Shiba Inu is the smallest of the six original
              and distinct spitz breeds of dog from Japan.
            </p>
          </mat-card-content>

          <mat-card-actions>
            <button mat-button>LIKE</button>
            <button mat-button>SHARE</button>
          </mat-card-actions>
        </mat-card>
        <div class="black" *ngIf="!fact">
          Loading ...
        </div>
    </mat-list>
  </cdk-virtual-scroll-viewport> -->